/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "juče",
        "-2": "prekjuče",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} dana",
          "one": "za {0} dan",
          "other": "za {0} dana"
        },
        "past": {
          "few": "prije {0} dana",
          "one": "prije {0} dana",
          "other": "prije {0} dana"
        }
      },
      "day-narrow": {
        "-1": "juče",
        "-2": "prekjuče",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} d.",
          "one": "za {0} d.",
          "other": "za {0} d."
        },
        "past": {
          "few": "prije {0} d.",
          "one": "prije {0} d.",
          "other": "prije {0} d."
        }
      },
      "day-short": {
        "-1": "juče",
        "-2": "prekjuče",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} d.",
          "one": "za {0} d.",
          "other": "za {0} d."
        },
        "past": {
          "few": "prije {0} d.",
          "one": "prije {0} d.",
          "other": "prije {0} d."
        }
      },
      "hour": {
        "0": "ovog sata",
        "future": {
          "few": "za {0} sata",
          "one": "za {0} sat",
          "other": "za {0} sati"
        },
        "past": {
          "few": "prije {0} sata",
          "one": "prije {0} sata",
          "other": "prije {0} sati"
        }
      },
      "hour-narrow": {
        "0": "ovog sata",
        "future": {
          "few": "za {0} č.",
          "one": "za {0} č.",
          "other": "za {0} č."
        },
        "past": {
          "few": "prije {0} č.",
          "one": "prije {0} č.",
          "other": "prije {0} č."
        }
      },
      "hour-short": {
        "0": "ovog sata",
        "future": {
          "few": "za {0} č.",
          "one": "za {0} č.",
          "other": "za {0} č."
        },
        "past": {
          "few": "prije {0} č.",
          "one": "prije {0} č.",
          "other": "prije {0} č."
        }
      },
      "minute": {
        "0": "ovog minuta",
        "future": {
          "few": "za {0} minuta",
          "one": "za {0} minut",
          "other": "za {0} minuta"
        },
        "past": {
          "few": "prije {0} minuta",
          "one": "prije {0} minuta",
          "other": "prije {0} minuta"
        }
      },
      "minute-narrow": {
        "0": "ovog minuta",
        "future": {
          "few": "za {0} min.",
          "one": "za {0} min.",
          "other": "za {0} min."
        },
        "past": {
          "few": "prije {0} min.",
          "one": "prije {0} min.",
          "other": "prije {0} min."
        }
      },
      "minute-short": {
        "0": "ovog minuta",
        "future": {
          "few": "za {0} min.",
          "one": "za {0} min.",
          "other": "za {0} min."
        },
        "past": {
          "few": "prije {0} min.",
          "one": "prije {0} min.",
          "other": "prije {0} min."
        }
      },
      "month": {
        "-1": "prošlog mjeseca",
        "0": "ovog mjeseca",
        "1": "sljedećeg mjeseca",
        "future": {
          "few": "za {0} mjeseca",
          "one": "za {0} mjesec",
          "other": "za {0} mjeseci"
        },
        "past": {
          "few": "prije {0} mjeseca",
          "one": "prije {0} mjeseca",
          "other": "prije {0} mjeseci"
        }
      },
      "month-narrow": {
        "-1": "prošlog mjes.",
        "0": "ovog mjes.",
        "1": "sljedećeg m.",
        "future": {
          "few": "za {0} m.",
          "one": "za {0} m.",
          "other": "za {0} m."
        },
        "past": {
          "few": "prije {0} m.",
          "one": "prije {0} m.",
          "other": "prije {0} m."
        }
      },
      "month-short": {
        "-1": "prošlog mjes.",
        "0": "ovog mjes.",
        "1": "sljedećeg mjes.",
        "future": {
          "few": "za {0} mjes.",
          "one": "za {0} mjes.",
          "other": "za {0} mjes."
        },
        "past": {
          "few": "prije {0} mjes.",
          "one": "prije {0} mjes.",
          "other": "prije {0} mjes."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "prošlog kvartala",
        "0": "ovog kvartala",
        "1": "sljedećeg kvartala",
        "future": {
          "few": "za {0} kvartala",
          "one": "za {0} kvartal",
          "other": "za {0} kvartala"
        },
        "past": {
          "few": "prije {0} kvartala",
          "one": "prije {0} kvartala",
          "other": "prije {0} kvartala"
        }
      },
      "quarter-narrow": {
        "-1": "prošlog kvartala",
        "0": "ovog kvartala",
        "1": "sledećeg kvartala",
        "future": {
          "few": "za {0} kv.",
          "one": "za {0} kv.",
          "other": "za {0} kv."
        },
        "past": {
          "few": "prije {0} kv.",
          "one": "prije {0} kv.",
          "other": "prije {0} kv."
        }
      },
      "quarter-short": {
        "-1": "prošlog kvartala",
        "0": "ovog kvartala",
        "1": "sledećeg kvartala",
        "future": {
          "few": "za {0} kv.",
          "one": "za {0} kv.",
          "other": "za {0} kv."
        },
        "past": {
          "few": "prije {0} kv.",
          "one": "prije {0} kv.",
          "other": "prije {0} kv."
        }
      },
      "second": {
        "0": "sada",
        "future": {
          "few": "za {0} sekunde",
          "one": "za {0} sekundu",
          "other": "za {0} sekundi"
        },
        "past": {
          "few": "prije {0} sekunde",
          "one": "prije {0} sekunde",
          "other": "prije {0} sekundi"
        }
      },
      "second-narrow": {
        "0": "sada",
        "future": {
          "few": "za {0} s.",
          "one": "za {0} s.",
          "other": "za {0} s."
        },
        "past": {
          "few": "prije {0} s.",
          "one": "prije {0} s.",
          "other": "prije {0} s."
        }
      },
      "second-short": {
        "0": "sada",
        "future": {
          "few": "za {0} sek.",
          "one": "za {0} sek.",
          "other": "za {0} sek."
        },
        "past": {
          "few": "prije {0} sek.",
          "one": "prije {0} sek.",
          "other": "prije {0} sek."
        }
      },
      "week": {
        "-1": "prošle sedmice",
        "0": "ove sedmice",
        "1": "sljedeće sedmice",
        "future": {
          "few": "za {0} sedmice",
          "one": "za {0} sedmicu",
          "other": "za {0} sedmica"
        },
        "past": {
          "few": "prije {0} sedmice",
          "one": "prije {0} sedmice",
          "other": "prije {0} sedmica"
        }
      },
      "week-narrow": {
        "-1": "prošle s.",
        "0": "ove s.",
        "1": "sljedeće s.",
        "future": {
          "few": "za {0} s.",
          "one": "za {0} s.",
          "other": "za {0} s."
        },
        "past": {
          "few": "prije {0} s.",
          "one": "prije {0} s.",
          "other": "prije {0} s."
        }
      },
      "week-short": {
        "-1": "prošle sedm.",
        "0": "ove sedm.",
        "1": "sljedeće sedm.",
        "future": {
          "few": "za {0} sedm.",
          "one": "za {0} sedm.",
          "other": "za {0} sedm."
        },
        "past": {
          "few": "prije {0} sedm.",
          "one": "prije {0} sedm.",
          "other": "prije {0} sedm."
        }
      },
      "year": {
        "-1": "prošle godine",
        "0": "ove godine",
        "1": "sljedeće godine",
        "future": {
          "few": "za {0} godine",
          "one": "za {0} godinu",
          "other": "za {0} godina"
        },
        "past": {
          "few": "prije {0} godine",
          "one": "prije {0} godine",
          "other": "prije {0} godina"
        }
      },
      "year-narrow": {
        "-1": "prošle g.",
        "0": "ove g.",
        "1": "sljedeće g.",
        "future": {
          "few": "za {0} g.",
          "one": "za {0} g.",
          "other": "za {0} g."
        },
        "past": {
          "few": "prije {0} g.",
          "one": "prije {0} g.",
          "other": "prije {0} g."
        }
      },
      "year-short": {
        "-1": "prošle god.",
        "0": "ove god.",
        "1": "sljedeće god.",
        "future": {
          "few": "za {0} god.",
          "one": "za {0} god.",
          "other": "za {0} god."
        },
        "past": {
          "few": "prije {0} god.",
          "one": "prije {0} god.",
          "other": "prije {0} god."
        }
      }
    },
    "locale": "sr-Latn-BA"
  });
}